module.exports = __webpack_public_path__ + "img/software_timesolv.8fda7eeb.jpg";